import {
    GET_STORE_ADDON_CATEGORIES,
    GET_ALL_STORE_CATEGORIES,
    GET_STORE_ITEMS,
    GET_STORE_ITEM,
    GET_SINGLE_STORE,
    GET_STORE_SORT_ITEM_CATEGORIES,
    GET_STORE_SORT_ITEMS,
    GET_STORE_ITEM_CATEGORIES,
    GET_ALL_PENDING_STORES,
    GET_ITEM_ADDON_CATEGORY,
    UPDATE_ITEM_ADDON_CATEGORY,
    GET_ALL_STORES
} from "./actionType";

const initialState = {
    store_categories: [],
    stores: [],
    pending_stores: [],
    singleStore: [],
    store_item_categories: [],
    sort_item_categories: [],
    sort_items: [],
    store_items: [],
    store_item: [],
    store_addon_categories: [],
    item_addon_category: [],
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ALL_STORE_CATEGORIES:
            return { ...state, store_categories: action.payload };
        case GET_ALL_STORES:
            return { ...state, stores: action.payload };
        case GET_SINGLE_STORE:
            return { ...state, singleStore: action.payload };
        case GET_STORE_SORT_ITEM_CATEGORIES:
            return { ...state, sort_item_categories: action.payload };
        case GET_STORE_SORT_ITEMS:
            return { ...state, sort_items: action.payload };
        case GET_STORE_ITEM_CATEGORIES:
            return { ...state, store_item_categories: action.payload };
        case GET_STORE_ITEMS:
            return { ...state, store_items: action.payload };
        case GET_STORE_ITEM:
            return { ...state, store_item: action.payload };
        case GET_STORE_ADDON_CATEGORIES:
            return { ...state, store_addon_categories: action.payload };
        case GET_ALL_PENDING_STORES:
            return { ...state, pending_stores: action.payload };
        case GET_ITEM_ADDON_CATEGORY:
            return { ...state, item_addon_category: action.payload };
        case UPDATE_ITEM_ADDON_CATEGORY:
            return { ...state, item_addon_category: action.payload };
        default:
            return state;
    }
}
